
export function AppSectionTitle({ title }: {
  title: string;
})
{
  return (
<h1 className="section-title">
  {title}
</h1>
  )
}
